var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.choseFile}},[_vm._t("default"),_c('input',{ref:"excel",staticClass:"file-hide",attrs:{"id":_vm.id,"type":"file","accept":".xlsx, .xls, .csv"},on:{"change":_vm.handleFileChange}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }